import { TableCell, TableRow, Typography } from "@mui/material"
import { Fragment } from "react"
import { OTHER_COLS_WIDTH } from "./constants"
import { RolesTableBodyRow } from "./roles-table-body"

export function UserRolesTableGroup({ groupKey, groups, roles }) {
    const group = groups[groupKey]
    return (
        <Fragment>
            <TableRow>
                <TableCell>
                    <Typography variant="overline" color="text.secondary">
                        {groupKey}
                    </Typography>
                </TableCell>
            </TableRow>
            {group.map((demand, groupDemandIx) => (
                <RolesTableBodyRow
                    key={`group-${groupDemandIx}`}
                    groups={groups}
                    group={groupKey}
                    roles={roles}
                    demand={demand}
                    groupDemandIx={groupDemandIx}
                />
            ))}
            <TableRow>
                <TableCell width={OTHER_COLS_WIDTH} sx={{ minWidth: OTHER_COLS_WIDTH }}>
                    {/* spacer */}{" "}
                </TableCell>
            </TableRow>
        </Fragment>
    )
}
